import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DelegationofauthorityService } from '../../../services/delegationofauthority/delegationofauthority.service';
import { Category } from '../../../interface/delegationofauthority/category';
import { Type } from '../../../interface/delegationofauthority/type';
import { Doatypelist } from '../../../interface/delegationofauthority/doatypelist';
import { RouterModule } from '@angular/router';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { EffectiveDateAndAmount, employeedetailsdirectreports } from '../../../interface/delegationofauthority/employeedetails';
import { SharedServices } from '../../../shared/services/shared.services';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DisplaypageComponent } from '../displaypage/displaypage.component';
import { Overlay } from '@angular/cdk/overlay';
import { LookupComponent } from '../../../shared/component/look-up/lookup.component';

@Component({
  selector: 'app-bydirectreport',
  templateUrl: './bydirectreport.component.html',
  imports: [CommonModule,FormsModule,ReactiveFormsModule, RouterModule, MatPaginatorModule, MatTableModule,MatProgressSpinner,LookupComponent],
  styleUrls: ['./bydirectreport.component.css']
})
export class BydirectreportComponent implements OnInit, AfterViewInit {
  categories: Category[] = [];
  types: Type[] = [];
  filteredTypes: Type[] = [];
  employees: Doatypelist[] = [];
  paginatedEmployees = new MatTableDataSource<Doatypelist>();
  displayedColumns: string[] = ['sno', 'name', 'jobTitle', 'phoneext', 'effectiveDate', 'dollar'];
  selectedCategory: string = '';
  selectedType: string = '';
  selectedEmail: string = '';
  selectedName: string = '';
  selectedJobTitle: string = '';
  selectedEffectiveDate: string = '';
  selectedDept: string = '';
  selectedDoa: string = '';
  selectedEmployeeNo: string = '';
  selectedDivision: string = '';
  showFields: boolean = false;
  isLoading: boolean = false; 
  recordsPerPage: number = 10;
  error: string | null = null;
  shouldSubmitForm: boolean = false;
  userInfo = { surname: '', otherNames: '', empEmail: '', costCenter: '', reportToEmail: '' };

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild('doaCategory') doaCategory!: ElementRef<HTMLSelectElement>;
  @ViewChild('doaTypes') doaTypes!: ElementRef<HTMLSelectElement>;
  @ViewChild('cai') cai!: ElementRef<HTMLInputElement>;

  constructor(
    private delegationService: DelegationofauthorityService,
    private sharedService: SharedServices,
    private dialog: MatDialog,
    private overlay: Overlay
  ) { }

  ngOnInit(): void {
    this.getCategories();
    this.getTypes();
  }

  ngAfterViewInit(): void {
    this.paginatedEmployees.paginator = this.paginator;
    if (this.shouldSubmitForm) {
      this.onSubmit();
    }
  }

  getCategories(): void {
    this.delegationService.getCategories().subscribe(
      (data: Category[]) => {
        this.categories = data;
        if (this.categories.length > 0) {
          this.selectedCategory = this.categories[0].catCode; // Set default category
          this.onCategoryChange();
        }
      },
    );
  }

  getTypes(): void {
    this.delegationService.getTypes().subscribe(
      (data: Type[]) => {
        this.types = data;
        this.onCategoryChange();
      },
    );
  }

  onCategoryChange(): void {
    this.filteredTypes = this.types.filter(type => type.catCode === this.selectedCategory);
  }
  onApproverSelected(selectedResult: any): void {  
    if (selectedResult && selectedResult.emailAddress) {
        this.selectedEmail = selectedResult.emailAddress
    }
  }
  onSubmit(): void {
    if (!this.selectedType) {
      this.sharedService.openModal('Message', 'Please select Doa Types');
      return;
    }
    if (!this.selectedEmail) {
      this.sharedService.openModal('Message', 'Email cannot be empty');
      return;
    }
    this.isLoading = true;
    this.showFields = true;
  
    this.delegationService.getEmployeeDetails(this.selectedEmail).subscribe((employee: employeedetailsdirectreports) => {
      this.selectedName = employee.fullName;
      this.selectedJobTitle = employee.jobTitle;
      this.selectedDept = employee.deptName;
      this.selectedDivision = employee.divisionName;
      this.selectedEmployeeNo = employee.employeeNo;
  
      this.delegationService.getDoaEffectiveDateAndAmount(employee.employeeNo, this.selectedCategory, this.selectedType).subscribe((data: EffectiveDateAndAmount) => {
        this.selectedEffectiveDate = data.effectiveDate;
        this.selectedDoa = data.dollar;
  
        this.delegationService.getEmployeesdirectreports(this.selectedCategory, this.selectedType, this.selectedEmail).subscribe((data: any) => {
          this.employees = data;
          // Assign serial numbers
          this.employees.forEach((item, index) => item.sno = index + 1);
          this.paginatedEmployees.data = this.employees;
          this.paginatedEmployees.paginator = this.paginator;
          this.isLoading = false;
        }, error => {
          // console.error('Error fetching employees', error);
          this.error = 'No Direct Reportee found for the Employee';
          this.isLoading = false;
          this.paginatedEmployees.data = [];
          this.showFields = false;
        });
      }, error => {
        // console.error('Error fetching effective date and amount', error);
        this.error = 'Effective Date and Amount not found for this employee';
        this.isLoading = false;
      });
    }, error => {
      // console.error('Error fetching employee details', error);
      this.error = 'Employee Information Not Found';
      this.isLoading = false;
    });
  }

  onPageChange(event: PageEvent): void {
    this.recordsPerPage = event.pageSize;
    this.paginatedEmployees.paginator = this.paginator;
  }

  navigateToDisplayPage(employeeNo: string): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '99%';
    dialogConfig.height = '99%';
    dialogConfig.data = { employeeNo };

    const dialogRef = this.dialog.open(DisplaypageComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  downloadExcel(): void {
    this.delegationService.getdirectreportsworksheet(this.selectedCategory, this.selectedType, this.selectedEmail).subscribe(
      (data: Blob) => {
        const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `DirectReWorksheet_${new Date().toISOString().slice(0, 19).replace(/:/g, '-')}.xlsx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      },
      error => {
        console.error('Error downloading the file', error);
      }
    ); 
  }
 
}